var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourcesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27121",
    "data-name": "Group 27121",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "station",
    d: "M6.922,15.7a6.344,6.344,0,0,1,.1-10.747.2.2,0,0,1,.1-.031.969.969,0,0,1,.906.136,1.058,1.058,0,0,1-.158,1.786A4.231,4.231,0,0,0,8,13.952H8a1.06,1.06,0,0,1,.327,1.386.982.982,0,0,1-1.316.414l-.032-.017-.011-.007L6.922,15.7Zm6.245-.057a.971.971,0,0,1-1.041.12,1.055,1.055,0,0,1-.05-1.85.1.1,0,0,1,.023-.024A4.231,4.231,0,0,0,12,6.764v0a1.06,1.06,0,0,1-.3-1.434.979.979,0,0,1,1.383-.306,6.347,6.347,0,0,1,.079,10.622ZM10,12.432a2.076,2.076,0,1,1,2-2.074A2.038,2.038,0,0,1,10,12.432Zm2.759,7.89a1,1,0,0,1-1.185-.8,1.038,1.038,0,0,1,.773-1.229A8.273,8.273,0,0,0,18,10.329a8.268,8.268,0,0,0-5.7-7.922.108.108,0,0,1-.03-.017,1.024,1.024,0,0,1-.7-.791A1.058,1.058,0,0,1,11.916.59.971.971,0,0,1,12.941.443,10.334,10.334,0,0,1,20,10.358a10.332,10.332,0,0,1-7.188,9.956A.2.2,0,0,1,12.759,20.323ZM7.146,20.3A10.334,10.334,0,0,1,0,10.358,10.334,10.334,0,0,1,7.12.423a.965.965,0,0,1,.1-.031h.008A.972.972,0,0,1,7.452.365a1.012,1.012,0,0,1,1,.9A1.037,1.037,0,0,1,7.722,2.4,8.268,8.268,0,0,0,2,10.367,8.267,8.267,0,0,0,7.735,18.32a1.021,1.021,0,0,1,.711.759,1.061,1.061,0,0,1-.3,1.011A.973.973,0,0,1,7.146,20.3Z",
    transform: "translate(6 5.642)",
    fill: "#adadad"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13381",
    "data-name": "Rectangle 13381",
    width: 32,
    height: 33,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/ResourcesIcon.b6bf652f.svg";
export { ForwardRef as ReactComponent };